import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./SideDrawer.module.css";

const DESKTOP_BREAKPOINT = 992;

const SideDrawer = ({
    open,
    onClose,
    width = 320,
    children,
}) => {

    const [isDesktop, setIsDesktop] = useState(
        window.innerWidth >= DESKTOP_BREAKPOINT
    );

    useEffect(() => {

        const handleResize = () => {

            setIsDesktop(
                window.innerWidth >= DESKTOP_BREAKPOINT
            );

        };

        window.addEventListener(
            "resize",
            handleResize
        );

        return () =>
            window.removeEventListener(
                "resize",
                handleResize
            );

    }, []);

    useEffect(() => {

        if (isDesktop) return;

        if (!open) return;

        const handleKeyDown = (event) => {

            if (event.key === "Escape") {

                onClose?.();

            }

        };

        document.body.style.overflow = "hidden";

        document.addEventListener(
            "keydown",
            handleKeyDown
        );

        return () => {

            document.body.style.overflow = "";

            document.removeEventListener(
                "keydown",
                handleKeyDown
            );

        };

    }, [
        open,
        onClose,
        isDesktop,
    ]);

    /**
     * Desktop Sidebar
     */

    if (isDesktop) {

        return (

            <aside
                className={styles.sidebar}
                style={{
                    width,
                }}
            >

                {children}

            </aside>

        );

    }

    /**
     * Mobile Drawer
     */

    if (!open) {

        return null;

    }

    return createPortal(

        <>

            <div
                className={styles.backdrop}
                onClick={onClose}
            />

            <aside
                className={styles.drawer}
                style={{
                    width,
                }}
                onClick={(event) =>
                    event.stopPropagation()
                }
            >

                {children}

            </aside>

        </>,

        document.body

    );

};

export default SideDrawer;